import { render } from "./PasswordChange.vue?vue&type=template&id=0e2f988e&scoped=true"
import script from "./PasswordChange.vue?vue&type=script&lang=js"
export * from "./PasswordChange.vue?vue&type=script&lang=js"

import "./PasswordChange.vue?vue&type=style&index=0&id=0e2f988e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2f988e"]])

export default __exports__